import { useCallback, useEffect } from 'react'

import { useDialog } from '@loadsmart/loadsmart-ui'
import { Dialog, Layout, Text } from '@loadsmart/miranda-react'

import { useAnalytics } from 'core/analytics/useAnalytics'

import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

export default function UserOnboardedDialog() {
  const { track } = useAnalytics()

  const { showUserOnboardedDialog, viewOnboardedDialog, openTrackingConnectionDrawer } =
    useTrackingOnboardingContext()

  const onboardedDialog = useDialog({ open: showUserOnboardedDialog })

  const handleOnMaybeLater = useCallback(() => {
    onboardedDialog.hide()
    viewOnboardedDialog()
    track('Ignored: Confirm preferred method dialog')
  }, [onboardedDialog, track, viewOnboardedDialog])

  const handleConfirm = useCallback(() => {
    onboardedDialog.hide()
    viewOnboardedDialog()
    openTrackingConnectionDrawer()
    track('Open setup: Confirm preferred method dialog')
  }, [onboardedDialog, openTrackingConnectionDrawer, track, viewOnboardedDialog])

  useEffect(() => {
    if (showUserOnboardedDialog) track('Viewed: Confirm preferred method dialog')
  }, [showUserOnboardedDialog, track])

  return (
    <Dialog open={onboardedDialog.open} size="medium">
      <Dialog.Header>
        <Text variant="heading-md-bold">Confirm your preferred tracking method</Text>
        <Dialog.Close onClick={handleOnMaybeLater} />
      </Dialog.Header>
      <Dialog.Body>
        <Layout.Stack gap="spacing-4">
          <Text variant="body-md">
            It looks like you've tried different tracking methods before, choose your preferred
            tracking method to enhance your experience tailored to your needs.
          </Text>
        </Layout.Stack>
      </Dialog.Body>
      <Dialog.Actions>
        <Dialog.ActionTertiary onClick={handleOnMaybeLater}>Maybe later</Dialog.ActionTertiary>
        <Dialog.ActionPrimary onClick={handleConfirm}>Choose preferred method</Dialog.ActionPrimary>
      </Dialog.Actions>
    </Dialog>
  )
}
